// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};


/** Image data-src observer **/
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
            observer.unobserve(img);

        }
    });
});

document.querySelectorAll('img[data-srcset]').forEach(img => {
    observer.observe(img);
});


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    //app.initLightbox(); // Use Spotlight for galleries - comment this in if you need it
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    //89app.initPopups();
    //app.initSpotlightJs();
    //app.initTingleModalJs();
    app.mainMenuController();
    app.initMotionOne();
    app.rangeSlider();
    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    //app.initWowJs();
    app.initStickyEl();
    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();


    let googleMaps = require('./modules/google-maps')();
    googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });

});


/*Stack Items Scroll */
document.addEventListener("DOMContentLoaded", function () {

    const stackItems = document.querySelectorAll('.stack-item');

    // 1. Define the function that calculates the offset
    const adjustStickyOffsets = () => {
        const viewportHeight = window.innerHeight;

        stackItems.forEach(item => {
            const itemHeight = item.offsetHeight;

            if (itemHeight > viewportHeight) {
                // If taller than screen:
                // Stick so the BOTTOM of the card lines up with bottom of screen
                const diff = itemHeight - viewportHeight;
                item.style.top = `-${diff}px`;
            } else {
                // If shorter than screen:
                // Stick to the top comfortably
                item.style.top = '0px';
            }
        });
    };

    // 2. Run immediately on load
    adjustStickyOffsets();

    // 3. Run on Window Resize
    window.addEventListener('resize', adjustStickyOffsets);

    // 4. Run whenever the size of a stack-item changes
    // (e.g., if an image loads inside a dynamic block)
    const observer = new ResizeObserver(adjustStickyOffsets);
    stackItems.forEach(item => observer.observe(item));
});




/*Wave Gradient */
const canvas = document.getElementById('liquid-canvas');
const ctx = canvas.getContext('2d');

let width, height;
let time = 0;

// Configuration
const waves = [
    {
        wavelength: 0.003, // How "tight" the wave is
        amplitude: 100,    // How tall the wave is
        speed: 0.005,       // How fast it moves
        color: 'rgb(255,107,0)', // Cyan-Blue
        offsetY: 0         // Vertical offset
    },
    {
        wavelength: 0.005,
        amplitude: 150,
        speed: 0.003,
        color: 'rgba(255,107,0,0.78)', // Purple
        offsetY: 50
    },
    {
        wavelength: 0.002,
        amplitude: 80,
        speed: 0.002,
        color: 'rgb(255,194,0)', // Greenish-Teal
        offsetY: -50
    }
];

function resize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
}
window.addEventListener('resize', resize);
resize();

function animate() {
    // 1. Clear with a slight trail for smoothness
    ctx.clearRect(0, 0, width, height);

    // 2. Set blend mode to make colors "glow" when they overlap
    // 'screen' or 'lighter' works best for glowing neon effects
    ctx.globalCompositeOperation = 'screen';

    // 3. Draw Each Wave
    waves.forEach(wave => {
        ctx.beginPath();
        ctx.fillStyle = wave.color;

        // Start drawing from left
        ctx.moveTo(0, height);

        // Loop across the width of the screen
        for (let x = 0; x <= width; x += 10) { // Step by 10px for performance
            // The Magic Formula: y = Center + Sine calculation
            const y = (height / 2) + wave.offsetY +
                Math.sin(x * wave.wavelength + time * wave.speed) * wave.amplitude +
                // Add a second sine wave for "organic" randomness
                Math.sin(x * wave.wavelength * 0.5 + time * wave.speed * 0.5) * (wave.amplitude / 2);

            ctx.lineTo(x, y);
        }

        // Close the shape to the bottom right and bottom left
        ctx.lineTo(width, height);
        ctx.lineTo(0, height);
        ctx.fill();
    });

    time += 5; // Increment time
    requestAnimationFrame(animate);
}

animate();
